var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonthlyArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.21967 11.2803C0.485936 11.5466 0.9026 11.5708 1.19621 11.3529L1.28033 11.2803L6.28033 6.28033C6.5466 6.01406 6.5708 5.5974 6.35295 5.30379L6.28033 5.21967L1.28033 0.21967C0.987437 -0.0732231 0.512563 -0.0732231 0.21967 0.21967C-0.0465966 0.485937 -0.0708027 0.9026 0.147052 1.19621L0.21967 1.28033L4.689 5.75L0.21967 10.2197C-0.0465966 10.4859 -0.0708027 10.9026 0.147052 11.1962L0.21967 11.2803Z",
    fill: "#587E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthlyArrowRight);
export default __webpack_public_path__ + "static/media/monthly-arrow-right.ffe9e9ae31c8a91395a48917c0004789.svg";
export { ForwardRef as ReactComponent };